import React from 'react';
import ActivityLoader from '../Common/ActivityLoader';
import Notification from '../Common/Notification';
import moment from 'moment';

const getPeriodLabel = (dayOfWeek) => {
  const today = moment().startOf('day');
  const classDate = moment().day(parseInt(dayOfWeek));
  const tomorrow = moment().add(1, 'days').startOf('day');

  if (classDate.isBefore(today)) return 'Next Week';
  if (classDate.isSame(today, 'day')) return 'Today';
  if (classDate.isSame(tomorrow, 'day')) return 'Tomorrow';
  if (classDate.isSameOrBefore(moment().endOf('week'))) return 'This Week';
  return 'Next Week';
};

const groupByDay = (classes) => {
  return classes.reduce((acc, curr) => {
    const day = curr.day_of_week_name;
    if (!acc[day]) acc[day] = [];
    acc[day].push(curr);
    return acc;
  }, {});
};

const badgeColors = ['primary', 'success', 'info', 'warning', 'danger', 'secondary', 'dark'];

const ScheduledClassCards = ({ scheduledClasses, onSchedule }) => {
  const grouped = groupByDay(scheduledClasses || []);
  const days = Object.keys(grouped);

  return (
    <div className="card">
      <div className="card-header d-flex justify-content-between align-items-center">
        <strong className="text-uppercase">Scheduled Classes</strong>
        <button className="btn btn-sm btn-primary" onClick={onSchedule}>
          <i className="fa fa-calendar-alt mr-1"></i> Schedule
        </button>
      </div>
      <div className="card-body overflow-auto" style={{ maxHeight: '40vw' }}>
        {Array.isArray(scheduledClasses) && scheduledClasses.length > 0 ? (
          <div className="vertical-timeline vertical-timeline--animate vertical-timeline--one-column">
            {days.map((day, i) => (
              grouped[day].length > 0 && (
                <div key={day}>
                  <h6 className="mb-3 text-uppercase text-dark border-bottom pb-1">{day.slice(0, 3)}</h6>
                  {grouped[day]
                    .sort((a, b) => moment(a.scheduled_time, 'hh:mm a') - moment(b.scheduled_time, 'hh:mm a'))
                    .map((item) => {
                      const periodLabel = getPeriodLabel(item.day_of_week);
                      const isToday = periodLabel === 'Today';
                      return (
                        <div
                          className={`vertical-timeline-item vertical-timeline-element ${isToday ? 'bg-light mb-3 border border-primary' : ''}`}
                          key={item.id}
                        >
                          <div>
                            <span className="vertical-timeline-element-icon bounce-in">
                              <i className={`badge badge-dot badge-dot-xl badge-${badgeColors[i % badgeColors.length]}`}>&nbsp;</i>
                            </span>
                            <div className="vertical-timeline-element-content bounce-in">
                              <h6 className="timeline-title mb-1 text-primary d-flex align-items-center justify-content-between">
                                {item.class?.class_name}
                                {item.class?.category && (
                                  <span className={`badge badge-pill badge-${badgeColors[(i + 2) % badgeColors.length]}`}>{item.class.category}</span>
                                )}
                              </h6>
                              {item.class?.trainer_name && (
                                <div className="text-muted mb-1">
                                  <i className="fa fa-user mr-1"></i>
                                  {item.class.trainer_name}
                                </div>
                              )}
                              <div className="text-muted mb-1">
                                <i className="fa fa-clock mr-1"></i>
                                {item.scheduled_time} for {item.duration_minutes} mins
                              </div>
                              <div className="text-muted">
                                <i className="fa fa-users mr-1"></i>
                                Max {item.max_participants} participants
                              </div>
                              <span className={`vertical-timeline-element-date mt-2 ${isToday ? 'text-primary font-weight-bold' : 'text-muted'}`}>
                                {periodLabel}
                              </span>&nbsp;
                            </div>
                          </div>
                        </div>
                      );
                    })}
                </div>
              )
            ))}
          </div>
        ) : scheduledClasses === '404' ? (
          <Notification message="No scheduled classes found." closable={false} />
        ) : (
          <ActivityLoader />
        )}
      </div>
    </div>
  );
};

export default ScheduledClassCards;
